import { AnalyticsService } from "../../../@core/utils/analytics.service";
import { AppSettingsService } from "../../../services/appsettings.service";
import { Component, Input } from "@angular/core";
import { NbSidebarService } from "@nebular/theme";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html"
})
export class HeaderComponent {
  /** Position d'affichage du menu */
  @Input() position = "normal";

  /* ###########################################  VARIABLES  #######################################################*/

  /** Session en cours */
  public h_currentUser: any;

  /** Menu utilisateur en haut à droite de l'écran */
  public h_userMenu = [
    {
      title: this.s_appsettings.proc_getTraduction("menu_header.pageProfil"),
      link: "/pages/commun/pageProfil"
    },
    {
      title: this.s_appsettings.proc_getTraduction("menu_header.login"),
      link: "/auth/login"
    }
  ];

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public sidebarService: NbSidebarService,
    public analyticsService: AnalyticsService,
    public s_appsettings: AppSettingsService,
    public s_translate: TranslateService
  ) {
    this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));

    /* Déconnection de la session et retour à l'acceuil suite à un rafraichisemment de la page */
    if (s_translate.currentLang == null) window.location.href = "";
  }

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * toggleSidebar
   */
  public toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    return false;
  }

  /**
   * startSearch
   */
  public startSearch() {
    this.analyticsService.trackEvent("startSearch");
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/@theme/components/header/header.component.ts